<template>
    <div>
        <div>
            <template v-if="worksheet.isCompleted">
                <span class="learnosity-report" id="convesationWorksheetReport"></span>
            </template>
            <template v-else>
                <div class="mt-3 mb-3 text-center">
                    <span v-if="worksheet.status === 0">Conversation worksheet is not started by subscriber.</span> 
                    <span v-if="worksheet.status === 1">Conversation worksheet is still in progress.</span> 
                </div>
            </template>
        </div>
        <hr class="mt-5">
        <div class="mt-5">
            <template v-if="scorecard.isCompleted">
                <span class="learnosity-report" id="convesationScorecardReport"></span>
            </template>
            <template v-else>
                <div class="mt-3 mb-3 text-center">
                    <template  v-if="worksheet.isCompleted">
                        <span v-if="scorecard.status === 0">Conversation scorecard is not started by subscriber.</span>
                        <span v-if="scorecard.status === 1">Conversation scorecard is still in progress.</span>
                    </template>
                    <template v-else>
                        <span>Conversation scorecard is not started by subscriber.</span>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
  /* global LearnosityReports:true */
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  
  export default {
    name: 'conversationQuestReport',
    props: ['worksheetParameter', 'scorecardParameter'],
    data () {
      return {
        reportsApp: {},
        scoringObjects: {},
        itemsAppTeacherScoring: {},
        careerIdeaAndConnection: {},
        worksheet: {
          status: 0,
          isCompleted: true
        },
        scorecard: {
          status: 0,
          isCompleted: true
        }
      }
    },
    mounted () {
      this.loadConversationReportForUser()
    },

    methods: {
      ...mapActions([
        'showClassAttemptReportForUser',
        'loadCareerIdeaAndConnectionForUser'
      ]),

      loadConversationReportForUser () {
        let userId = this.worksheetParameter.userId
        let courseId = this.worksheetParameter.courseId
        let worksheetSessionId = this.worksheetParameter.sessionId
        this.loadCareerIdeaAndConnectionForUser({courseId: courseId, userId: userId, isMainQuest: true}).then(res => {
          if (res) {
            this.careerIdeaAndConnection = res
          }
        })
        this.showClassAttemptReportForUser({userId: userId, sessionId: worksheetSessionId, courseId: courseId, widgetId: 'convesationWorksheetReport'}).then(data => {
          this.worksheet.status = this.worksheetParameter.status
          this.worksheet.isCompleted = this.worksheetParameter.isCompleted
          if (data && this.worksheet.isCompleted) {
            this.initializeWorksheetReport(data)
          }
        })
        let scorecardSessionId = this.scorecardParameter.sessionId
        this.showClassAttemptReportForUser({userId: userId, sessionId: scorecardSessionId, courseId: courseId, widgetId: 'convesationScorecardReport'}).then(data => {
          this.scorecard.status = this.scorecardParameter.status
          this.scorecard.isCompleted = this.scorecardParameter.isCompleted
          if (data && this.scorecard.isCompleted) {
            this.initializeScorecardReport(data)
          }
        })
      },

      initializeWorksheetReport (data) {
        const signedRequest = JSON.parse(data.signedRequest)
        this.reportsApp = LearnosityReports.init(signedRequest, {
          'readyListener': () => {
            this.bindWorksheetReadyListener(data)
          },
          'errorListener': (event) => {
            console.log('error: ', event)
          }
        })
      },

      bindWorksheetReadyListener (data) {
        let userCareerCriteriaList = data.userCareerCriteriaList
        let report = this.reportsApp.getReport('convesationWorksheetReport')
        report.on('ready:questionsApi', (questionsApp) => {
          $('.lrn-report-question-title').hide()
          let elem = '.lrn-well'
          $(elem).hide()
          $(elem).next().hide()
          $('table').hide()
          $('table.table-bordered').show()
          $('table.lrn_choicematrix_type_table').show()
          setTimeout(() => {
            let pos = 0
            let questions = questionsApp.questions()
            $.each(questions, (responseId, questionObject) => {
              let question = questionObject.getQuestion()
              if (Object.keys(this.careerIdeaAndConnection).length > 0) {
                this.showCareerIdeaAndConnection(question, this.careerIdeaAndConnection)
              }
              if (userCareerCriteriaList && userCareerCriteriaList.length > 0) {
                let stimulus = question.stimulus
                if (stimulus) {
                  pos = this.showUserCareerCriteriaList(question, userCareerCriteriaList, pos)
                }
              }
            })
          }, 0)
        })
      },

      initializeScorecardReport (data) {
        const signedRequest = JSON.parse(data.signedRequest)
        this.reportsApp = LearnosityReports.init(signedRequest, {
          'readyListener': () => {
            this.bindScorecardReadyListener(data)
          },
          'errorListener': (event) => {
            console.log('error: ', event)
          }
        })
      },

      bindScorecardReadyListener (data) {
        let userCareerCriteriaList = data.userCareerCriteriaList
        let report = this.reportsApp.getReport('convesationScorecardReport')
        report.on('ready:questionsApi', (questionsApp) => {
          $('.lrn-report-question-title').hide()
          let elem = '.lrn-well'
          $(elem).hide()
          $(elem).next().hide()
          $('table').hide()
          $('table.table-bordered').show()
          $('table.lrn_choicematrix_type_table').show()
          $('.lrn_ratingInfo_icon_wrap').hide()
          setTimeout(() => {
            let pos = 0
            let questions = questionsApp.questions()
            $.each(questions, (responseId, questionObject) => {
              let question = questionObject.getQuestion()
              if (Object.keys(this.careerIdeaAndConnection).length > 0) {
                this.showCareerIdeaAndConnection(question, this.careerIdeaAndConnection)
              }
              if (userCareerCriteriaList && userCareerCriteriaList.length > 0) {
                let stimulus = question.stimulus
                if (stimulus) {
                  pos = this.showUserCareerCriteriaList(question, userCareerCriteriaList, pos)
                }
              }
            })
          }, 0)
        })
      },

      showUserCareerCriteriaList (question, careerCriteriaList, pos) {
        let selector = '#' + question.response_id + ' > div.lrn_question > div.lrn_stimulus > div.lrn_stimulus_content'
        $(selector).children().each(function (i) {
          let text = $(this).text()
          if (text.toLowerCase().indexOf('criteria ') === 0) {
            let label = careerCriteriaList[pos].label
            let value = careerCriteriaList[pos].value
            if (value) {
              $(this).html(label + '<br/>' + value)
            } else {
              $(this).html(label)
            }
            pos += 1
          }
        })
        return pos
      },

      showCareerIdeaAndConnection (question, careerIdeaAndConnection) {
        let self = this
        let parent = '#' + question.response_id + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div'
        let tableSelector = parent + ' > table.table-bordered > tbody > tr:eq(1)'
        $(tableSelector).children().each(function (i) {
          let text = $(this).text()
          if (text === '#name') {
            let value = careerIdeaAndConnection.firstName + ' ' + careerIdeaAndConnection.lastName
            let elem = '<span id="name">' + (value || '') + '</span>'
            $(this).html(elem)
          } else if (text === '#organization') {
            let value = careerIdeaAndConnection.organization
            let elem = '<span id="organization">' + (value || '') + '</span>'
            $(this).html(elem)
          } else if (text === '#careeridea') {
            let value = careerIdeaAndConnection.title
            let elem = '<span id="title">' + (value || '') + '</span>'
            $(this).html(elem)
          } else if ((text === '') || (text === '#date')) {
            let millis = careerIdeaAndConnection.meetingDate
            let value = self.changeMillisToDate(millis)
            if (value || (text === '#date')) {
              let elem = '<span id="meetingDate">' + (value || '') + '</span>'
              $(this).html(elem)
            }
          }
        })

        $(parent).children().each(function (i) {
          let text = $(this).text()
          if (text === '#sample') {
            $(this).hide()
          }
        })
      },

      changeMillisToDate (millis) {
        if (millis) {
          return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
        }
        return null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/app/assessment/components/ConversationQuestReport.vue